// packages/core/src/learning/DebateMeta.ts
// ─────────────────────────────────────────────────────────────────────────
// Debates are their own entity. A debate is between TWO schools, so it can't
// live "inside" either one — instead each school's exhibit references the
// debate ids it participates in.
//
// Debate tone (per the Nisk Tone Guide):
//   - Fair, clear, honest, slightly punchy.
//   - Frame tradeoffs, not winners.
//   - "What is each school paying attention to?"
//
// Authored via prompts/04_debates.txt.
// ─────────────────────────────────────────────────────────────────────────

import type { SchoolOfThought } from './LearningTypes';

export type DebateId = string;

export interface DebateEntry {
	id: DebateId;
	/** Short title, e.g. "Boglehead vs Value investing". */
	title: string;
	/** The two schools in tension. Order isn't semantic. */
	schoolA: SchoolOfThought;
	schoolB: SchoolOfThought;
	/** A 1–2 sentence framing of the tension. Fair, not tribal. */
	tagline: string;
	/** What schoolA is paying attention to that schoolB underweights. */
	tradeoffA: string;
	/** What schoolB is paying attention to that schoolA underweights. */
	tradeoffB: string;
	/** A plain sentence on what this changes for the user in real life. */
	practicalImplication: string;
	/** Optional short-form hook ready for marketing. */
	marketingHook?: string;
	revision: number;
}

export const DEBATES: Record<DebateId, DebateEntry> = {
	// Populated by running prompts/04_debates.txt.
};

// ── Lookups ──────────────────────────────────────────────────────────────
export function getDebate(id: string): DebateEntry | undefined {
	return DEBATES[id];
}

